import { useState, useEffect } from "react";

function useMarketPackageLoading(list) {
    const [isLoadingMP, setisLoadingMP] = useState(true);

    useEffect(() => {
        // if (list.length) {
            setisLoadingMP(false);
        // } else setisLoadingMP(true);
    }, [list]);

    return isLoadingMP;
}

export default useMarketPackageLoading;
